import { useState, useEffect, useCallback } from 'react';
import { stagesApi, Stage } from '../../inbox/services/stagesApi';

export const useFunnelStages = () => {
  const [stages, setStages] = useState<Stage[]>([]);
  const [loading, setLoading] = useState(true);

  const loadStages = useCallback(async () => {
    try {
      setLoading(true);
      const data = await stagesApi.fetchStages();
      setStages(data);
    } catch (error) {
      console.error('[useFunnelStages] Error loading stages:', error);
      setStages([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStages();
  }, [loadStages]);

  return {
    stages,
    loading,
    reload: loadStages,
  };
};
